import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import deniedImg from "../asset/accessdenied.png";

const InstructorAccessDenied = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const message = location.state?.reason || "Documents verification pending. Please contact administrator.";

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-100 to-gray-200 px-4">
      <div className="bg-white shadow-xl rounded-lg p-8 max-w-md w-full text-center">
        <img
          src={deniedImg}
          alt="Access Denied"
          className="w-40 mx-auto mb-6"
        />
        <p className="text-gray-700 mb-4">{message}</p>
        <p className="text-sm text-gray-600 mb-6">
          Contact us at{" "}
          <span className="text-blue-600 font-medium underline">Skillara@gmail.com</span>
        </p>
        <button
          onClick={() => navigate("/instructor-login")}
          className="w-full py-3 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition duration-300"
        >
          Back to Login
        </button>
      </div>
    </div>
  );
};

export default InstructorAccessDenied;